import React from 'react';

/**
 * The classic cartoon bomb — a plain round ball, a stubby cap, and a curling
 * lit fuse. Colours are hardcoded rather than `currentColor`/theme-driven on
 * purpose: a bomb tied to `--ink` turned solid black in dark mode, which sat
 * on the (also very dark) cell background with almost no contrast — the
 * "bombs disappear in dark mode" bug. A fixed light ball with a dark outline
 * reads clearly on both a light and a dark cell, which a single colour
 * flipped by theme cannot do at once.
 */
export function MineIcon(): React.ReactElement {
  return (
    <svg className="icon-mine" viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <circle cx="16" cy="19" r="9" fill="#ececed" stroke="#1c1c1e" strokeWidth="1.4" />
      <circle cx="12.9" cy="15.8" r="2.4" fill="#ffffff" />

      {/* Cap the fuse sits in. */}
      <rect x="14.5" y="9" width="3" height="2.6" rx="0.7" fill="#ececed" stroke="#1c1c1e" strokeWidth="1.2" />

      {/* The fuse, curling up and away, ending in a lit spark. */}
      <path
        d="M16 9c0-1.9 1.3-2.8 2.6-3.1"
        fill="none"
        stroke="#1c1c1e"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <circle cx="19.3" cy="5.1" r="1.8" fill="#ff9f0a" />
      <circle cx="19.3" cy="5.1" r="0.8" fill="#ffd60a" />
    </svg>
  );
}

/** A flag on a pole, matching the bomb's weight. */
export function FlagIcon(): React.ReactElement {
  return (
    <svg className="icon-flag" viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <path d="M11 4.5v23" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" />
      <path d="M6.5 27.5h13" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" />
      <path d="M12.6 5.6l12 4.6-12 4.6z" fill="#ff453a" />
    </svg>
  );
}

/** Marks a flag that turned out to be wrong once the board is face-up. */
export function WrongFlagIcon(): React.ReactElement {
  return (
    <svg className="icon-flag" viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <g stroke="currentColor" strokeWidth="3" strokeLinecap="round">
        <path d="M8 8l16 16M24 8L8 24" />
      </g>
    </svg>
  );
}
